import { StandardEvents } from '@shopify/events';

/**
 * Floute le panier et affiche un loader centre pendant TOUTE action panier
 * (voir cart-loading-overlay.liquid pour le detail complet) - un seul
 * ecouteur central sur document, pas un par composant.
 *
 * Compteur plutot qu'un simple booleen : si deux actions panier se
 * chevauchent (rare vu que chaque composant se desactive deja pendant sa
 * propre requete, mais pas garanti - ex: deux onglets du meme panier), le
 * calque ne doit disparaitre qu'une fois la DERNIERE des actions en cours
 * reellement terminee, jamais avant.
 */
let pendingCount = 0;

/** @returns {HTMLElement | null} */
function getOverlay() {
  return document.querySelector('[data-cart-loading-overlay]');
}

function show() {
  pendingCount += 1;
  const overlay = getOverlay();
  if (overlay) overlay.hidden = false;
}

function hide() {
  pendingCount = Math.max(0, pendingCount - 1);
  if (pendingCount > 0) return;
  const overlay = getOverlay();
  if (overlay) overlay.hidden = true;
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  show();
  event.promise
    ?.then(() => hide())
    .catch(() => hide());
});
